import { SegmentedControl } from '@mantine/core';
import { useNavigate, useParams, useLocation } from 'react-router';
import { sfyr } from '@epilogo/core/src/_ctx/sfyr';

export const LanguageToggle = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = lang === 'it' ? 'it' : 'en';

  const handleChange = (value: string) => {
    sfyr.context.update(() => ({ lang: value }));
    const pathWithoutLang = location.pathname.replace(/^\/(en|it)/, '');
    navigate(`/${value}${pathWithoutLang}${location.search}${location.hash}`, { replace: true });
  };

  return (
    <SegmentedControl
      size='xs'
      value={currentLang}
      onChange={handleChange}
      data={[
        { label: 'EN', value: 'en' },
        { label: 'IT', value: 'it' },
      ]}
    />
  );
};
